import { forwardRef, useCallback } from 'react';
import { useSnackbar, SnackbarContent, CustomContentProps } from 'notistack';
import Color from 'color';

import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import { Download } from 'lucide-react';

interface ReportCompleteProps extends CustomContentProps {
  allowDownload?: boolean;
  downloadHandler?: () => void;
}

export const ClipReadySnackBar = forwardRef<HTMLDivElement, ReportCompleteProps>(
  ({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();
    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const green = Color('#12b76a');

    return (
      <SnackbarContent
        ref={ref}
        sx={{
          '@media (min-width:600px)': {
            minWidth: '344px !important',
          },
        }}
      >
        <Alert
          variant="filled"
          onClose={handleDismiss}
          sx={{
            color: green.lighten(0.95).toString(),
            backgroundColor: green.toString(),
          }}
        >
          <AlertTitle sx={{ color: 'white' }}>
            <Typography variant="body1">
              {props.message || 'Your clip is ready!'}
            </Typography>
          </AlertTitle>

          <Button
            variant="filled"
            startIcon={<Download />}
            onClick={props.downloadHandler}
            sx={{
              padding: 0,
              textTransform: 'none',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.99967 1.45825C7.16076 1.45825 7.29134 1.58884 7.29134 1.74992L7.29134 11.5458L11.1684 7.66868C11.2823 7.55478 11.467 7.55478 11.5809 7.66868C11.6948 7.78258 11.6948 7.96725 11.5809 8.08116L7.20591 12.4562C7.09201 12.5701 6.90734 12.5701 6.79344 12.4562L2.41844 8.08116C2.30453 7.96726 2.30453 7.78258 2.41843 7.66868C2.53234 7.55478 2.71701 7.55478 2.83091 7.66868L6.70801 11.5458L6.70801 1.74992C6.70801 1.58884 6.83859 1.45825 6.99967 1.45825Z"
                fill="white"
              />
            </svg>
          </Button>
        </Alert>
      </SnackbarContent>
    );
  },
);

ClipReadySnackBar.displayName = 'ClipReadySnackBar';

export default ClipReadySnackBar;
